import { Typography, Tabs, Tab, Box } from '@mui/material';


function Tab2Component (props) {
    return (
      <div>
        <Typography variant="h5" component="h2">
          Tab 2 Content
        </Typography>
      </div>
    );
  };

  export default Tab2Component